// 常量相关的定义
export const MAX_PAGE_SIZE = 1000;

// 56个民族
export const ethnicGroups = [
  { label: "汉族", value: "汉族" },
  { label: "蒙古族", value: "蒙古族" },
  { label: "回族", value: "回族" },
  { label: "藏族", value: "藏族" },
  { label: "维吾尔族", value: "维吾尔族" },
  { label: "苗族", value: "苗族" },
  { label: "彝族", value: "彝族" },
  { label: "壮族", value: "壮族" },
  { label: "布依族", value: "布依族" },
  { label: "朝鲜族", value: "朝鲜族" },
  { label: "满族", value: "满族" },
  { label: "侗族", value: "侗族" },
  { label: "瑶族", value: "瑶族" },
  { label: "白族", value: "白族" },
  { label: "土家族", value: "土家族" },
  { label: "哈尼族", value: "哈尼族" },
  { label: "哈萨克族", value: "哈萨克族" },
  { label: "傣族", value: "傣族" },
  { label: "黎族", value: "黎族" },
  { label: "傈僳族", value: "傈僳族" },
  { label: "佤族", value: "佤族" },
  { label: "畲族", value: "畲族" },
  { label: "高山族", value: "高山族" },
  { label: "拉祜族", value: "拉祜族" },
  { label: "水族", value: "水族" },
  { label: "东乡族", value: "东乡族" },
  { label: "纳西族", value: "纳西族" },
  { label: "景颇族", value: "景颇族" },
  { label: "柯尔克孜族", value: "柯尔克孜族" },
  { label: "土族", value: "土族" },
  { label: "达斡尔族", value: "达斡尔族" },
  { label: "仫佬族", value: "仫佬族" },
  { label: "羌族", value: "羌族" },
  { label: "布朗族", value: "布朗族" },
  { label: "撒拉族", value: "撒拉族" },
  { label: "毛南族", value: "毛南族" },
  { label: "仡佬族", value: "仡佬族" },
  { label: "锡伯族", value: "锡伯族" },
  { label: "阿昌族", value: "阿昌族" },
  { label: "普米族", value: "普米族" },
  { label: "塔吉克族", value: "塔吉克族" },
  { label: "怒族", value: "怒族" },
  { label: "乌兹别克族", value: "乌兹别克族" },
  { label: "俄罗斯族", value: "俄罗斯族" },
  { label: "鄂温克族", value: "鄂温克族" },
  { label: "德昂族", value: "德昂族" },
  { label: "保安族", value: "保安族" },
  { label: "裕固族", value: "裕固族" },
  { label: "京族", value: "京族" },
  { label: "塔塔尔族", value: "塔塔尔族" },
  { label: "独龙族", value: "独龙族" },
  { label: "鄂伦春族", value: "鄂伦春族" },
  { label: "赫哲族", value: "赫哲族" },
  { label: "门巴族", value: "门巴族" },
  { label: "珞巴族", value: "珞巴族" },
  { label: "基诺族", value: "基诺族" },
];

// levelKeys
export const levelKeys = ["level1", "level2", "level3"]; // 你关心的 levelX

// 用章申请的的查询参数 状态
export const STAMP_STATUS = [
  { label: "待审批", value: 0 },
  { label: "审批通过", value: 1 },
  { label: "审批驳回", value: 2 },
  { label: "取消", value: 3 },
  { label: "待归还", value: 13 },
  { label: "已归还", value: 14 },
];

// 采购申请的审批状态
export const APPROVAL_STATUS_OPTIONS = [
  { label: "待一级审批", value: 10 },
  { label: "一级审批通过", value: 11 },
  { label: "一级审批驳回", value: 12 },
  { label: "待二级审批", value: 20 },
  { label: "二级审批通过", value: 21 },
  { label: "二级审批驳回", value: 22 },
  { label: "待三级审批", value: 30 },
  { label: "三级审批通过", value: 31 },
  { label: "三级审批驳回", value: 32 },
  { label: "审批通过", value: 1 },
  { label: "审批驳回", value: 2 },
  { label: "已取消", value: 3 },
];

// 只有一级审批
export const APPROVAL_TYPE_1 = ["章"];

// 只有单选且只有一级审批
export const APPROVAL_TYPE_2 = ["报废"];

// 固定类型
export const DAILY_NAME = "日常消耗物资";

// 低值易耗物资
export const CONSUMABLES_NAME = "低值易耗物资";

// 固定物资
export const FIXED_NAME = "固定物资";


// 测试上传
export const UPLOAD_URL =
  "https://api.bl-creation.cn/file/upload";



// 生产上传
// export const UPLOAD_URL =
//   "https://api.erminzu.cn/file/upload";


// 低值易耗物资 固定物资的审批状态
export const APPROVE_STATUS_MAP = {
  0: "待审批",
  1: "通过",
  2: "拒绝",
};
